import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "More.svg",
  "use": "More.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"More.svg\"><path d=\"M53.0208,32.0208a5,5,0,1,1-5-5A5,5,0,0,1,53.0208,32.0208Zm-16,0a5,5,0,1,1-5-5A5,5,0,0,1,37.0209,32.0208Zm-21-5a5,5,0,1,1-5,5A5,5,0,0,1,16.0207,27.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol